import {
  calendar_date_picker_styles_default
} from "./chunk.7VXMOI6I.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __commonJS,
  __decorateClass,
  __toESM
} from "./chunk.K2NRSETB.js";

// node_modules/calendator/index.js
var require_calendator = __commonJS({
  "node_modules/calendator/index.js"(exports, module) {
    "use strict";
    (function() {
      var EMPTY_CALENDAR = Object.freeze([]);
      var NUMBER_OF_DAYS_IN_A_WEEK = 7;
      var SUN = 0;
      var MON = 1;
      var TUE = 2;
      var WED = 3;
      var THU = 4;
      var FRI = 5;
      var SAT = 6;
      var WEEKDAYS = {
        SUN,
        MON,
        TUE,
        WED,
        THU,
        FRI,
        SAT
      };
      Object.freeze(WEEKDAYS);
      var JAN = 0;
      var FEB = 1;
      var MAR = 2;
      var APR = 3;
      var MAY = 4;
      var JUN = 5;
      var JUL = 6;
      var AUG = 7;
      var SEP = 8;
      var OCT = 9;
      var NOV = 10;
      var DEC = 11;
      var MONTHS = {
        JAN,
        FEB,
        MAR,
        APR,
        MAY,
        JUN,
        JUL,
        AUG,
        SEP,
        OCT,
        NOV,
        DEC
      };
      Object.freeze(MONTHS);
      function isTypeOf(type, test) {
        if (typeof type !== "string")
          return false;
        return typeof test === type;
      }
      function isNotTypeOf(type, test) {
        if (!isTypeOf("string", test))
          return false;
        return !isTypeOf(type, test);
      }
      function isDate(test) {
        return test instanceof Date;
      }
      function isNotDate(test) {
        return !isDate(test);
      }
      function isInNumericWeekdayRange(numericWeekday) {
        return numericWeekday >= SUN && numericWeekday <= SAT;
      }
      function isInMonthRange(month) {
        return month >= JAN && month <= DEC;
      }
      function isNotInMonthRange(month) {
        return !isInMonthRange(month);
      }
      function createEmptyWeek() {
        return [null, null, null, null, null, null, null];
      }
      function defaultDayCreationHandler(year, month, currentDay) {
        return currentDay;
      }
      function Calendator2(startWeekWithThisWeekday, dayCreationHandler, fillDaysForPrevAndNextMonths) {
        this._startWeekday = isInNumericWeekdayRange(startWeekWithThisWeekday) ? startWeekWithThisWeekday : SUN;
        this._dayCreationHandler = isTypeOf("function", dayCreationHandler) ? dayCreationHandler : defaultDayCreationHandler;
        this._fillDaysForPrevAndNextMonths = Boolean(fillDaysForPrevAndNextMonths);
        this._cachedCalendars = {};
      }
      Calendator2.prototype.getMonths = function() {
        return MONTHS;
      };
      Calendator2.prototype.getWeekdays = function() {
        return WEEKDAYS;
      };
      Calendator2.prototype.giveMeCalendarForMonthYear = function(month, year) {
        var guardCases = isNotTypeOf("number", month) || isNotTypeOf("number", year) || isNotInMonthRange(month);
        if (guardCases)
          return EMPTY_CALENDAR;
        var cachedCalendar = this._getCachedCalendarForMonthYear(month, year);
        if (cachedCalendar)
          return cachedCalendar;
        var calendar = this._buildCalendarForMonthYear(month, year);
        this._cacheCalendar(month, year, calendar);
        return calendar;
      };
      Calendator2.prototype.getCalendarForMonthYear = Calendator2.prototype.giveMeCalendarForMonthYear;
      Calendator2.prototype.giveMeCalendarForDate = function(date) {
        if (isNotDate(date))
          return EMPTY_CALENDAR;
        var month = date.getMonth();
        var year = date.getFullYear();
        var calendar = this.giveMeCalendarForMonthYear(month, year);
        return calendar;
      };
      Calendator2.prototype.getCalendarForDate = Calendator2.prototype.giveMeCalendarForDate;
      Calendator2.prototype._buildCalendarForMonthYear = function(month, year) {
        var dateForLastDayOfMonth = new Date(year, month + 1, 0);
        var dateForFirstDayOfMonth = new Date(year, month, 1);
        var weekdayOfFirstDayInMonth = dateForFirstDayOfMonth.getDay();
        var numberOfDaysInMonth = dateForLastDayOfMonth.getDate();
        var calendar = [];
        var currentDay = 1;
        var currentWeek = 1;
        var week = createEmptyWeek();
        var weekday = this._offsetByStartWeekday(weekdayOfFirstDayInMonth);
        while (currentDay <= numberOfDaysInMonth) {
          week[weekday] = this._dayCreationHandler(year, month, currentDay, weekday, currentWeek);
          weekday++;
          currentDay++;
          var weekIsFull = Boolean(week[week.length - 1]);
          if (weekIsFull) {
            if (this._fillDaysForPrevAndNextMonths && currentWeek === 1) {
              var dateForLastDayOfPreviousMonth = new Date(year, month, 0);
              var previousMonth = month - 1;
              var numberOfDaysInPreviousMonth = dateForLastDayOfPreviousMonth.getDate();
              for (var i = week.length - 1; i > -1; i--) {
                if (week[i])
                  continue;
                week[i] = this._dayCreationHandler(year, previousMonth, numberOfDaysInPreviousMonth, i, currentWeek);
                numberOfDaysInPreviousMonth--;
              }
            }
            calendar.push(week);
            week = createEmptyWeek();
            weekday = SUN;
            currentWeek++;
          } else if (currentDay > numberOfDaysInMonth) {
            if (this._fillDaysForPrevAndNextMonths) {
              var weekdayOfFirstDayInNextMonth = 1;
              var nextMonth = month + 1;
              for (var j = 0; j < week.length; j++) {
                if (week[j])
                  continue;
                week[j] = this._dayCreationHandler(year, nextMonth, weekdayOfFirstDayInNextMonth, j, currentWeek);
                weekdayOfFirstDayInNextMonth++;
              }
            }
            calendar.push(week);
          }
        }
        return calendar;
      };
      Calendator2.prototype._cacheCalendar = function(month, year, calendarToBeCached) {
        var cachedYear = this._cachedCalendars[year];
        if (!cachedYear) {
          cachedYear = {};
          this._cachedCalendars[year] = cachedYear;
        }
        cachedYear[month] = calendarToBeCached;
      };
      Calendator2.prototype._getCachedCalendarForMonthYear = function(month, year) {
        var cachedCalendars = this._cachedCalendars;
        var cachedYear = cachedCalendars[year];
        if (!cachedYear)
          return null;
        var cachedMonth = cachedYear[month];
        return cachedMonth ? cachedMonth : null;
      };
      Calendator2.prototype._offsetByStartWeekday = function(weekday) {
        weekday -= this._startWeekday;
        if (weekday < 0)
          return weekday + NUMBER_OF_DAYS_IN_A_WEEK;
        return weekday;
      };
      Calendator2.SUN = SUN;
      Calendator2.MON = MON;
      Calendator2.TUE = TUE;
      Calendator2.WED = WED;
      Calendator2.THU = THU;
      Calendator2.FRI = FRI;
      Calendator2.SAT = SAT;
      Calendator2.WEEKDAYS = WEEKDAYS;
      Calendator2.JAN = JAN;
      Calendator2.FEB = FEB;
      Calendator2.MAR = MAR;
      Calendator2.APR = APR;
      Calendator2.MAY = MAY;
      Calendator2.JUN = JUN;
      Calendator2.JUL = JUL;
      Calendator2.AUG = AUG;
      Calendator2.SEP = SEP;
      Calendator2.OCT = OCT;
      Calendator2.NOV = NOV;
      Calendator2.DEC = DEC;
      Calendator2.MONTHS = MONTHS;
      Object.freeze(Calendator2);
      if (typeof module !== "undefined" && module.exports) {
        module.exports = Calendator2;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("Calendator", [], function() {
          return Calendator2;
        });
      } else {
        if (!window.dv)
          window.dv = {};
        window.dv.Calendator = Calendator2;
      }
    })();
  }
});

// src/components/calendar/calendar-date-picker.ts
var import_calendator = __toESM(require_calendator(), 1);
import { t as t2 } from "i18next";
var FadvCalendarDatePicker = class extends s {
  constructor() {
    super(...arguments);
    this.mode = "date";
    this.keyboardSelection = false;
  }
  initialize() {
    const calendar = new import_calendator.default(void 0, (year, month, day) => new Date(year, month, day), true);
    const weekDates = calendar.giveMeCalendarForMonthYear(this.state.workingDate.getMonth(), this.state.workingDate.getFullYear());
    this.dates = weekDates.reduce((curr, next) => curr.concat(next), []);
  }
  handleKeydown(event) {
    const date = this.state.workingDate.getDate();
    const month = this.state.workingDate.getMonth();
    const year = this.state.workingDate.getFullYear();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    let dateDiff = 0;
    switch (event.key) {
      case "ArrowUp":
        dateDiff = -7;
        break;
      case "ArrowDown":
        dateDiff = 7;
        break;
      case "ArrowLeft":
        dateDiff = -1;
        break;
      case "ArrowRight":
        dateDiff = 1;
        break;
      case "Home":
        dateDiff = 1 - date;
        break;
      case "End":
        dateDiff = daysInMonth - date;
        break;
      case "PageUp":
        dateDiff = event.altKey ? -365 : -daysInMonth;
        break;
      case "PageDown":
        dateDiff = event.altKey ? 365 : daysInMonth;
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.keyboardSelection = true;
    const nextWorkingDate = new Date(this.state.workingDate.setDate(date + dateDiff));
    this.emitDateChange(nextWorkingDate);
    requestAnimationFrame(() => {
      var _a, _b;
      (_b = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(`button[aria-label="${nextWorkingDate.toLocaleDateString()}"]`)) == null ? void 0 : _b.focus();
    });
  }
  handleNextClick() {
    this.keyboardSelection = false;
    this.emitDateChange(new Date(this.state.workingDate.setMonth(this.state.workingDate.getMonth() + 1)));
  }
  handlePrevClick() {
    this.keyboardSelection = false;
    this.emitDateChange(new Date(this.state.workingDate.setMonth(this.state.workingDate.getMonth() - 1)));
  }
  getNavigationLabel() {
    const month = t2(`components:calendar.monthsFull.${this.state.workingDate.getMonth()}`);
    return `${month} ${this.state.workingDate.getFullYear()}`;
  }
  createClickHandler(date, isDisabled) {
    return () => {
      if (isDisabled)
        return;
      this.keyboardSelection = false;
      this.clearRangePreview();
      this.emitDateChange(date, true);
    };
  }
  createMouseenterHandler(date) {
    return (e) => {
      var _a, _b;
      const target = e.target;
      target.classList.add("calendar-date-picker__active");
      if (!this.state.isRange)
        return;
      if (!this.state.rangeStart)
        return;
      if (this.state.rangeStart > date)
        return;
      if (this.state.rangeEnd)
        return;
      let dateElement = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(".calendar-date-picker__range-start");
      if (!dateElement) {
        dateElement = (_b = this.shadowRoot) == null ? void 0 : _b.querySelector(".calendar-date-picker__date");
      }
      if (!dateElement)
        return;
      while (dateElement.nextElementSibling) {
        dateElement.classList.add("calendar-date-picker__range-preview");
        dateElement = dateElement == null ? void 0 : dateElement.nextElementSibling;
        if (dateElement === target)
          break;
      }
      target.classList.add("calendar-date-picker__range-preview");
    };
  }
  handleMouseLeave(e) {
    const target = e.target;
    target.classList.remove("calendar-date-picker__active");
    this.clearRangePreview();
  }
  clearRangePreview() {
    var _a;
    if (!this.state.isRange)
      return;
    const dateElements = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll(".calendar-date-picker__date");
    dateElements == null ? void 0 : dateElements.forEach((e) => e.classList.remove("calendar-date-picker__range-preview"));
  }
  emitDateChange(date, selectDate) {
    emit(this, "fadv-date-changed", { detail: { date, mode: "date", selectDate } });
  }
  handleLabelClick() {
    emit(this, "fadv-cal-nav-mode-change");
  }
  focus(options) {
    var _a, _b;
    let selector = 'button[tabindex="0"]';
    if (this.state.workingDate) {
      selector = `button[aria-label="${this.state.workingDate.toLocaleDateString()}"]`;
    }
    (_b = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(selector)) == null ? void 0 : _b.focus(options);
  }
  renderDate(date) {
    const { isRange, rangeStart, rangeEnd, workingDate, currentDate, selectedDate } = this.state;
    const dateValue = date.valueOf();
    const dateMonth = date.getMonth();
    const workingMonth = workingDate.getMonth();
    const isNextMonth = dateMonth > workingMonth;
    const isLastMonth = dateMonth < workingMonth;
    const isRangeStart = isRange && dateValue === (rangeStart == null ? void 0 : rangeStart.valueOf());
    const isRangeEnd = isRange && dateValue === (rangeEnd == null ? void 0 : rangeEnd.valueOf());
    const isInRangePreview = isRange && !!rangeStart && !rangeEnd && date >= rangeStart && date <= workingDate;
    const isInRange = isRange && !!rangeStart && !!rangeEnd && dateValue >= rangeStart.valueOf() && dateValue <= rangeEnd.valueOf();
    const isSelected = dateValue === (selectedDate == null ? void 0 : selectedDate.valueOf()) || isRangeStart || isRangeEnd;
    const isDisabled = !!this.state.maxDate && date > this.state.maxDate || !!this.state.minDate && date < this.state.minDate;
    const dayIndex = date.getDay();
    const isCurrent = dateValue === currentDate.valueOf();
    const isWorkingDate = this.keyboardSelection && dateValue === workingDate.valueOf();
    function renderDay(day) {
      if (isLastMonth || isNextMonth) {
        return $`<fadv-typography type="label-medium" variant="neutral" scale="300">${day}</fadv-typography>`;
      }
      return $`<fadv-typography type="label-medium">${day}</fadv-typography>`;
    }
    return $`<button class=${o({
      "calendar-date-picker__date": true,
      "calendar-date-picker__date-disabled": isDisabled,
      "calendar-date-picker__date-current": isCurrent,
      "calendar-date-picker__date-selected": isSelected,
      "calendar-date-picker__last-month": isLastMonth,
      "calendar-date-picker__next-month": isNextMonth,
      "calendar-date-picker__active": isWorkingDate,
      "calendar-date-picker__range": isInRange,
      "calendar-date-picker__range-preview": isInRangePreview,
      "calendar-date-picker__range-start": isRangeStart,
      "calendar-date-picker__range-end": isRangeEnd,
      "calendar-date-picker__start-of-week": dayIndex === 0,
      "calendar-date-picker__end-of-week": dayIndex === 6
    })} tabindex=${isWorkingDate ? "0" : "-1"} aria-label="${date.toLocaleDateString()}" aria-selected=${isSelected} aria-disabled=${isDisabled} @click=${this.createClickHandler(date, isDisabled)} @mouseenter=${this.createMouseenterHandler(date)} @mouseleave=${this.handleMouseLeave} ><span aria-hidden="true">${renderDay(date.getDate())}</span></button>`;
  }
  renderDayOfWeek(index) {
    const dayFull = t2(`components:calendar.daysFull.${index}`);
    const dayShort = t2(`components:calendar.daysShort.${index}`);
    return $`<div class="calendar-date-picker__day-of-week" aria-hidden="true"><fadv-typography type="label-medium" weight="500" aria-label=${dayFull}>${dayShort}</fadv-typography></div>`;
  }
  render() {
    this.initialize();
    return $`<div class="calendar-date-picker"><div class="calendar-navigator"><div class="calendar-navigator__title"><button aria-label=${t2("components:calendar.chooseMonthYear")} @click=${this.handleLabelClick}><fadv-typography variant="primary" type="heading-small" weight="500">${this.getNavigationLabel()}</fadv-typography></button></div><div class="calendar-navigator__controls"><button aria-label=${t2("components:calendar.monthPrevious")} @click=${this.handlePrevClick}><fadv-icon size="small" foreground="primary" library="solid" name="fa-chevron-left"></fadv-icon></button><button aria-label=${t2("components:calendar.monthNext")} @click=${this.handleNextClick}><fadv-icon size="small" foreground="primary" library="solid" name="fa-chevron-right"></fadv-icon></button></div></div><div class="calendar-date-picker__dates" aria-label=${t2("components:calendar.dates")} @keydown=${this.handleKeydown}>${Array.from({ length: 7 }).map((_, i) => this.renderDayOfWeek(i))} ${this.dates.map((d) => this.renderDate(d))}</div></div>`;
  }
};
FadvCalendarDatePicker.styles = calendar_date_picker_styles_default;
__decorateClass([
  t()
], FadvCalendarDatePicker.prototype, "dates", 2);
__decorateClass([
  t()
], FadvCalendarDatePicker.prototype, "state", 2);
__decorateClass([
  t()
], FadvCalendarDatePicker.prototype, "keyboardSelection", 2);
__decorateClass([
  t()
], FadvCalendarDatePicker.prototype, "rangeEndPreview", 2);
FadvCalendarDatePicker = __decorateClass([
  n("fadv-calendar-date-picker")
], FadvCalendarDatePicker);

export {
  FadvCalendarDatePicker
};
